import React from "react";
import { FileCode2, Check, Loader2, RotateCw, Monitor } from "lucide-react";

const IMG = "https://images.unsplash.com/photo-1662532577856-e8ee8b138a8b?crop=entropy&cs=srgb&fm=jpg&q=80&w=900";

const ChatSide = () => (
  <div className="hidden md:flex flex-col gap-3 w-[38%] border-r border-slate-200 p-4 bg-slate-50/80">
    <div className="self-end max-w-[90%] rounded-2xl rounded-tr-sm bg-slate-100 border border-slate-200 px-3.5 py-2.5 text-xs text-slate-800">
      Build an online shopping app for my clothing brand “Saffron Threads”
    </div>
    <div className="self-start max-w-[95%] rounded-2xl rounded-tl-sm bg-slate-100 border border-slate-200 px-3.5 py-3 text-xs text-slate-600 space-y-2">
      <p>Done! A bold storefront with filters, sizes and a working bag.</p>
      <div className="rounded-lg bg-slate-50 border border-slate-200 p-2 font-mono text-[10px] space-y-1">
        {["index.html", "styles.css"].map((f) => (
          <div key={f} className="flex items-center gap-1.5 text-emerald-600"><Check size={11} /> {f}</div>
        ))}
        <div className="flex items-center gap-1.5 text-amber-600"><Loader2 size={11} className="animate-spin" /> app.js <span className="text-slate-400">· 214 lines</span></div>
      </div>
    </div>
    <div className="self-end max-w-[90%] rounded-2xl rounded-tr-sm bg-slate-100 border border-slate-200 px-3.5 py-2.5 text-xs text-slate-800">
      Make the hero red and add a sale banner
    </div>
    <div className="mt-auto rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-[11px] text-slate-500">Ask for a change…</div>
  </div>
);

const PreviewSide = () => (
  <div className="flex-1 flex flex-col bg-slate-50">
    <div className="h-9 border-b border-slate-200 px-3 flex items-center justify-between text-[10px] font-mono text-slate-500">
      <span className="flex items-center gap-2"><Monitor size={12} /> ishukart.org/p/saffron-threads</span>
      <RotateCw size={11} />
    </div>
    <div className="flex-1 p-3">
      <div className="h-full rounded-lg overflow-hidden bg-[#FFF7ED] text-[#1c1917] flex flex-col">
        <div className="bg-[#B91C1C] text-slate-900 text-[9px] tracking-widest text-center py-1 font-semibold">FESTIVE SALE · 30% OFF</div>
        <div className="flex items-center justify-between px-4 py-2 text-[10px] font-semibold"><span className="font-display text-sm">Saffron Threads</span><span>Bag (2)</span></div>
        <div className="flex-1 grid grid-cols-5 gap-3 px-4 pb-4">
          <div className="col-span-3 flex flex-col justify-center gap-2">
            <p className="font-display text-xl sm:text-2xl font-bold leading-tight">Wear the colour of celebration.</p>
            <p className="text-[10px] text-stone-600">Hand-finished kurtas, co-ords and drapes.</p>
            <span className="mt-1 w-fit rounded-full bg-[#1c1917] text-slate-900 text-[10px] px-3 py-1.5">Shop the edit</span>
          </div>
          <img src={IMG} alt="Clothing brand preview" className="col-span-2 h-full w-full object-cover rounded-md" />
        </div>
      </div>
    </div>
  </div>
);

export const WorkspaceMockup = () => (
  <div className="relative rounded-2xl border border-slate-200 bg-white shadow-[0_30px_120px_-20px_rgba(16,185,129,0.25)] overflow-hidden" data-testid="landing-workspace-mockup">
    <div className="h-10 border-b border-slate-200 px-4 flex items-center gap-2">
      <span className="w-2.5 h-2.5 rounded-full bg-rose-500/70" /><span className="w-2.5 h-2.5 rounded-full bg-amber-400/70" /><span className="w-2.5 h-2.5 rounded-full bg-emerald-500/70" />
      <span className="ml-3 flex items-center gap-1.5 text-[11px] font-mono text-slate-500"><FileCode2 size={12} /> Saffron Threads · v3</span>
      <span className="ml-auto text-[10px] font-mono px-2 py-0.5 rounded bg-emerald-50 border border-emerald-200 text-emerald-700">Published</span>
    </div>
    <div className="flex h-[340px] sm:h-[400px]">
      <ChatSide />
      <PreviewSide />
    </div>
  </div>
);

export default WorkspaceMockup;
